/**
 * Feature Flags - ArenaStats Performance OS
 * 
 * Controla features disponíveis por ambiente/modo
 * Default: Performance Mode (B2B)
 */

export const FEATURES = {
  // Social Network Features (disabled por padrão)
  ENABLE_SOCIAL_FEED: process.env.REACT_APP_ENABLE_SOCIAL === 'true',
  ENABLE_CHAT: process.env.REACT_APP_ENABLE_SOCIAL === 'true',
  ENABLE_NOTIFICATIONS_SOCIAL: process.env.REACT_APP_ENABLE_SOCIAL === 'true',
  ENABLE_COMMUNITIES: process.env.REACT_APP_ENABLE_SOCIAL === 'true',
  
  // Performance OS Features (sempre ativo)
  ENABLE_RBAC: true,
  ENABLE_AGENDA: true,
  ENABLE_TRAINING: true,
  ENABLE_ANALYTICS: true,
  ENABLE_LIBRARY: true,
  ENABLE_AI: true,
  
  // Governance (admin only)
  ENABLE_GOVERNANCE: true,
  
  // Visual Branding
  ENABLE_CLAW_SIGNATURE: process.env.REACT_APP_ENABLE_CLAW_SIGNATURE !== 'false',

  // Sport-specific
  ENABLE_SWIMMING: true,
  ENABLE_FOOTBALL: true,
  ENABLE_TRIATHLON: true,
  ENABLE_AMERICAN_FOOTBALL: true,

  // VUKZ Sensor UI (fora do MVP — fail-closed default false)
  // Set REACT_APP_ENABLE_VUKZ_SENSOR_UI=true para reativar blocos de wearable/sensor.
  // Sincronizado com backend ENABLE_VUKZ_SENSOR — se backend não monta, frontend esconde.
  ENABLE_VUKZ_SENSOR_UI: process.env.REACT_APP_ENABLE_VUKZ_SENSOR_UI === 'true',

  // SwimVision UI (07/08/2026 — RESERVA DE LANÇAMENTO, não código morto):
  // produto será lançado à parte; até lá aba + card no perfil do atleta
  // (CoachAthleteDetailPage) ficam escondidos. NÃO remover TabSwimVision
  // em limpeza de DEAD_CANDIDATE — volta no launch.
  // Set REACT_APP_ENABLE_SWIMVISION_UI=true para reexibir.
  ENABLE_SWIMVISION_UI: process.env.REACT_APP_ENABLE_SWIMVISION_UI === 'true',

  // Monitoramento de Carga do Prep (07/08/2026 — RESERVA DE REATIVAÇÃO, não
  // código morto): a tela misturava duas fontes — o plano computado
  // (physical_load_entries → vw_athlete_load_summary → physical_alerts, são
  // e reutilizável) e o plano SEEDADO do demo Acqua (athlete_load_tracking +
  // agenda_ai_alerts, ACWR 2.81 inventado). Sem cano execução→carga, a tela
  // dava conselho de treino sobre número falso. Desligada até o ciclo do
  // cano. NÃO remover PrepDashboardPage/sp_detect_physical_alerts/
  // vw_athlete_load_summary em limpeza de DEAD_CANDIDATE.
  // Set REACT_APP_ENABLE_PREP_LOAD_UI=true para reexibir.
  ENABLE_PREP_LOAD_UI: process.env.REACT_APP_ENABLE_PREP_LOAD_UI === 'true',

  // Governance Builder (Gate P1 — desativado por padrão, fail-closed)
  // Set REACT_APP_GOV_BUILDER_ENABLED=true para reativar UI do Builder.
  // Sincronizado com backend GOV_BUILDER_ENABLED (proteção real é no servidor).
  GOV_BUILDER_ENABLED: process.env.REACT_APP_GOV_BUILDER_ENABLED === 'true',
};

// Product Mode
export const PRODUCT_MODE = {
  SOCIAL: 'social',
  PERFORMANCE: 'performance',
};

export const CURRENT_MODE = FEATURES.ENABLE_SOCIAL_FEED 
  ? PRODUCT_MODE.SOCIAL 
  : PRODUCT_MODE.PERFORMANCE;
